var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtherTraceIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 11,
    height: 11.0128,
    viewBox: "0 0 11 11.0128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.16667 0H1.83333C1.34728 0.000699466 0.881305 0.232977 0.537614 0.645884C0.193923 1.05879 0.000582214 1.61861 0 2.20255V8.81019C0.000582214 9.39413 0.193923 9.95395 0.537614 10.3669C0.881305 10.7798 1.34728 11.012 1.83333 11.0127H3.85733H9.16667C9.65272 11.012 10.1187 10.7798 10.4624 10.3669C10.8061 9.95395 10.9994 9.39413 11 8.81019V2.20255C10.9994 1.61861 10.8061 1.05879 10.4624 0.645884C10.1187 0.232977 9.65272 0.000699466 9.16667 0Z",
    fill: "#37B1E5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 21_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M9.05682 3.93754C9.70896 3.93782 10.2372 4.46732 10.2374 5.11948C10.2371 5.77156 9.7089 6.29976 9.05682 6.30004C8.40454 6.29999 7.87515 5.7717 7.87488 5.11948C7.87506 4.46718 8.40449 3.93759 9.05682 3.93754Z",
    fill: "#E7F4FA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    d: "M5.89452 3.93754C6.54666 3.93782 7.0749 4.46732 7.07508 5.11948C7.0748 5.77156 6.5466 6.29976 5.89452 6.30004C5.24225 6.29999 4.71286 5.7717 4.71258 5.11948C4.71276 4.46718 5.24219 3.93759 5.89452 3.93754Z",
    fill: "#E7F4FA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    d: "M2.74466 3.93752C3.39679 3.9378 3.92503 4.4673 3.92522 5.11946C3.92494 5.77154 3.39674 6.29974 2.74466 6.30002C2.09238 6.29997 1.56299 5.77168 1.56272 5.11946C1.5629 4.46716 2.09233 3.93757 2.74466 3.93752Z",
    fill: "#E7F4FA"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.86286 10.1317H10.2669C10.3997 10.1308 10.532 10.1125 10.6615 10.077C10.4931 10.3655 10.2694 10.6012 10.0093 10.764C9.74915 10.9268 9.46025 11.0121 9.16695 11.0127L7.14308 11.0128H1.8335C1.34745 11.0121 0.881475 10.7798 0.537785 10.3669C0.194094 9.95402 0.00075313 9.3942 0.000170916 8.81027V2.20263C0.000742642 1.70134 0.143631 1.21528 0.405231 0.824751C0.666831 0.434219 1.03149 0.162578 1.43897 0.0547016C1.21899 0.424317 1.10054 0.867224 1.10017 1.32161V7.92925C1.10075 8.51318 1.29409 9.073 1.63778 9.48591C1.98147 9.89882 2.44745 10.1311 2.9335 10.1318L7.86286 10.1317Z",
    fill: "#1589BB",
    fillOpacity: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherTraceIcon);
export default __webpack_public_path__ + "static/media/other-trace-icon.62197a5f0cc036edbe3f3f4f9776c290.svg";
export { ForwardRef as ReactComponent };